import { lazy } from "react";
import Protected from "../pages/auth/Protected";
import Dashboard from "../pages/dashboard/Dashboard.jsx";
const Profile = lazy(() => import("../pages/member/Profile.jsx"));

export const commonRoutes = [
    { path: "/", element: <Protected Component={Dashboard} /> },
    { path: "/profile", element: <Protected Component={Profile} /> },
]